"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    marginBottom: {
      marginBottom: 20
    },
    formLabel: {
      fontSize: 12,
      marginTop: 3
    },
    colorPicker: {
      width: "100%",
      marginTop: ".2rem",
      marginBottom: "1rem"
    }
  };
});

var AttributesContainer = function AttributesContainer(_ref) {
  var objectsForm = _ref.objectsForm,
      properties = _ref.properties,
      handleItemAttribute = _ref.handleItemAttribute,
      handlePropertyChange = _ref.handlePropertyChange;
  var classes = useStyles();
  var attributes = properties.attributes;
  return "no estan definidas las propiedades";
};

var _default = AttributesContainer;
exports.default = _default;